export default __webpack_public_path__ + "static/B0053-6301652774382865d9ba5d27213c46ef.png";